import React from 'react';
import { Link } from 'react-router-dom';

const CaseApplications = ({ apps, uniDocProgress, id, caseRec }) => {
    return (
        <div className="bg-gray-800 border border-gray-700 rounded-lg shadow-lg overflow-hidden">
            <div className="bg-gray-900/50 p-4 border-b border-gray-700 flex justify-between items-center">
                <h4 className="text-lg font-bold text-blue-400 uppercase tracking-wider flex items-center gap-2">
                    🎓 UNIVERSITY APPLICATIONS
                </h4>
                <Link to={`/admin/univ_apps/new?case_id=${id}${caseRec?.client_id ? `&client_id=${caseRec.client_id}` : ''}`} className="px-3 py-1.5 rounded text-xs font-bold bg-blue-600 text-white hover:bg-blue-700 uppercase tracking-wider border border-blue-500">
                    + New App
                </Link>
            </div>
            <div className="w-full overflow-x-auto">
                <table className="w-full text-left border-collapse">
                    <thead>
                        <tr className="bg-gray-900 border-b border-gray-700 text-xs font-bold text-gray-500 uppercase tracking-wider">
                            <th className="p-4">University • Program</th>
                            <th className="p-4">Status</th>
                            <th className="p-4">Portal Ref</th>
                            <th className="p-4">Deadline</th>
                            <th className="p-4">Updated</th>
                            <th className="p-4">Checklist</th>
                            <th className="p-4 text-right">Actions</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-700 font-mono text-sm">
                        {apps.map(a => (
                            <tr key={a.id} className="hover:bg-gray-700/30 transition-colors">
                                <td className="p-4 text-white">
                                    <div className="font-bold">{a.programs?.universities?.name || 'Unknown Uni'}</div>
                                    <div className="text-xs text-gray-400 mt-1">{a.programs?.name || 'Unknown Program'}</div>
                                </td>
                                <td className="p-4">
                                    <span className={`px-2 py-1 rounded text-[10px] font-bold uppercase border ${a.status === 'submitted' ? 'bg-blue-900/30 text-blue-400 border-blue-800' : 'bg-gray-700 text-gray-400 border-gray-600'}`}>
                                        {a.status || 'draft'}
                                    </span>
                                </td>
                                <td className="p-4 text-gray-300">{a.metadata?.portal_ref || '-'}</td>
                                <td className="p-4 text-gray-300 text-xs">
                                    {a.metadata?.deadline || a.intakes?.apply_close || '-'}
                                </td>
                                <td className="p-4 text-gray-400 text-xs">{a.updated_at ? new Date(a.updated_at).toLocaleString() : '-'}</td>
                                <td className="p-4">
                                    {(() => {
                                        const p = uniDocProgress[a.id] || { done: 0, total: 0 };
                                        return (
                                            <div className="flex items-center gap-2">
                                                <div className="w-16 h-1.5 bg-gray-700 rounded-full overflow-hidden">
                                                    <div className="h-full bg-blue-500" style={{ width: `${p.total ? (p.done / p.total) * 100 : 0}%` }}></div>
                                                </div>
                                                <span className="text-xs text-gray-400">{p.done}/{p.total}</span>
                                            </div>
                                        );
                                    })()}
                                </td>
                                <td className="p-4 text-right">
                                    <Link
                                        to={`/admin/univ_apps/${a.id}`}
                                        className="inline-flex items-center gap-1 px-3 py-1.5 rounded text-[11px] font-bold bg-gray-900 text-blue-300 hover:bg-gray-800 border border-gray-700 uppercase tracking-wider"
                                    >
                                        View
                                    </Link>
                                </td>
                            </tr>
                        ))}
                        {apps.length === 0 && (
                            <tr>
                                <td colSpan="5" className="p-8 text-center text-gray-500 uppercase">No applications found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default CaseApplications;
